import React, { useState, useEffect } from 'react';
import TestCard from './TestCard';
import SearchFilter from './SearchFilter';
import TestsSummary from './TestsSummary';
import '../css/testsSummary.css';

const TabContentTodosTests = ({ 
  testsRepaso,
  testsGenerales,
  filteredTests, 
  inicioNumeracion, 
  finNumeracion, 
  searchTerm, 
  setSearchTerm, 
  handleOnClic, 
  onDescargarTest 
}) => {
  // Estado para rastrear la categoría seleccionada
  const [categoriaActiva, setCategoriaActiva] = useState('todos');
  
  // Estado local para la paginación
  const [localInicio, setLocalInicio] = useState(0);
  const [localFin, setLocalFin] = useState(6);
  
  // Resetear paginación cuando cambie la categoría o el término de búsqueda
  useEffect(() => {
    setLocalInicio(0);
    setLocalFin(6);
  }, [categoriaActiva, searchTerm]);
  
  // Función para manejar la paginación local
  const handleLocalPaginacion = (e) => {
    // Obtener el id del elemento clickeado o su elemento padre
    let elementId = e.target.id;
    
    // Si no tiene id, buscar en el elemento padre (para cuando se hace clic en el icono)
    if (!elementId && e.target.parentElement) {
      elementId = e.target.parentElement.id;
    }
    
    if (elementId === 'siguiente') {
      const nuevoInicio = localInicio + 6;
      const nuevoFin = localFin + 6;
      
      setLocalInicio(nuevoInicio);
      setLocalFin(nuevoFin);
    } else if (elementId === 'anterior') {
      const nuevoInicio = Math.max(0, localInicio - 6);
      const nuevoFin = nuevoInicio + 6;
      
      setLocalInicio(nuevoInicio);
      setLocalFin(nuevoFin);
    }
  };
  
  // Función para filtrar tests según la categoría seleccionada y el término de búsqueda
  const getTestsFiltrados = () => {
    let testsBase;
    
    console.log('=== FILTRADO DE TESTS ===');
    console.log(`Categoría activa: ${categoriaActiva}`);
    console.log(`Tests disponibles: Total ${filteredTests.length}, Repaso ${testsRepaso.length}, Generales ${testsGenerales.length}`);
    
    if (categoriaActiva === 'repaso') {
      testsBase = testsRepaso;
      console.log('Seleccionados tests de repaso');
    }
    else if (categoriaActiva === 'generales') {
      testsBase = testsGenerales;
      console.log('Seleccionados tests generales');
    }
    else {
      testsBase = filteredTests; // Todos los tests
      console.log('Seleccionados todos los tests');
    }
    
    // Filtrar por término de búsqueda si existe
    if (searchTerm) {
      console.log(`Término de búsqueda: "${searchTerm}"`);
      const termino = searchTerm.toLowerCase();
      const testsFiltrados = testsBase.filter(test => 
        (test.numero_test && test.numero_test.toString().includes(termino)) || 
        (test.tema && test.tema.toString().includes(termino)) ||
        (test.descripcion && test.descripcion.toLowerCase().includes(termino))
      );
      console.log(`Resultados de búsqueda: ${testsFiltrados.length} tests`);
      return testsFiltrados;
    }
    
    console.log(`Total tests a mostrar: ${testsBase.length}`);
    console.log('=== FIN FILTRADO DE TESTS ===\n');
    return testsBase;
  };
  
  const testsMostrados = getTestsFiltrados();
  return (
    <div className="tab-content todos-tests-content">
      <SearchFilter searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      
      {/* Componente de resumen de tests */}
      <TestsSummary 
        testsRepaso={testsRepaso}
        testsGenerales={testsGenerales}
        filteredTests={filteredTests}
        categoriaActiva={categoriaActiva}
      />
      
      {/* Selector de categorías */}
      <div className="category-selector">
        <div 
          className={`category-tab ${categoriaActiva === 'todos' ? 'active' : ''}`}
          onClick={() => setCategoriaActiva('todos')}
        >
          <i className="fas fa-list"></i> Todos los tests
        </div>
        <div 
          className={`category-tab ${categoriaActiva === 'repaso' ? 'active' : ''}`}
          onClick={() => setCategoriaActiva('repaso')}
        >
          <i className="fas fa-sync-alt"></i> Tests de repaso
        </div>
        <div 
          className={`category-tab ${categoriaActiva === 'generales' ? 'active' : ''}`}
          onClick={() => setCategoriaActiva('generales')}
        >
          <i className="fas fa-book"></i> Tests generales
        </div>
      </div>
      
      <div className="tests-grid">
        {localInicio > 0 && (
          <div className="pagination-arrow prev" id="anterior" onClick={handleLocalPaginacion}>
            <i className="fas fa-chevron-left"></i>
          </div>
        )}
        
        {testsMostrados.slice(localInicio, localFin).map((test, index) => (
          <TestCard 
            key={index} 
            test={test} 
            onDescargar={onDescargarTest} 
          />
        ))}
        
        {localFin < testsMostrados.length && testsMostrados.length > 6 && (
          <div className="pagination-arrow next" id="siguiente" onClick={handleLocalPaginacion}>
            <i className="fas fa-chevron-right"></i>
          </div>
        )}
      </div>
      
      <div className="pagination-info">
        Mostrando {testsMostrados.length > 0 ? localInicio + 1 : 0} - {Math.min(localFin, testsMostrados.length)} de {testsMostrados.length} tests
      </div>
    </div>
  );
};

export default TabContentTodosTests;